"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toastr_1 = __importDefault(require("toastr"));
const projections_1 = require("~/openlayers/projections");
const locale_1 = require("~/services/locale");
const settings_1 = require("~/settings");
/**
 * Echelles disponibles
 */
const customScales = [
    {
        scale: 500000,
        ratio: 3
    },
    {
        scale: 250000,
        ratio: 3
    },
    {
        scale: 100000,
        ratio: 3
    },
    {
        scale: 50000,
        ratio: 3
    },
    {
        scale: 25000,
        ratio: 3
    },
];
;
// const apikey = 'ign_scan_ws';
OpenLayers.Util.upperCaseObject = function (object) {
    var uObject = {};
    for (var key in object) {
        uObject[key === 'apikey' ? key : key.toUpperCase()] = object[key];
    }
    return uObject;
};
/**
 * Ce module permet de générer les fonds de carte issus de IGN.
 *
 * En prérequis, la clé doit être initialisée dans JGN.GEOPORTAL_KEY
 */
const Geoportal = {
    /**
     * Description des fonds de carte
     */
    layersOptions: [
        {
            permalinkId: 'ign.carte',
            name: 'Carte IGN',
            layer: 'GEOGRAPHICALGRIDSYSTEMS.MAPS',
            imagePath: 'img/ign-carte.jpg',
            style: 'normal',
            private: true,
            // On a un quota d'utilisation :(
            limitUsage: false,
            alternateLayerId: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGN',
        },
        {
            permalinkId: 'ign.photo',
            name: 'Photos IGN',
            layer: 'ORTHOIMAGERY.ORTHOPHOTOS',
            imagePath: 'img/ign-photo.jpg',
            style: 'normal',
        },
        {
            permalinkId: 'ign.cadastre',
            name: 'Cadastre IGN',
            layer: 'CADASTRALPARCELS.PARCELLAIRE_EXPRESS',
            imagePath: 'img/ign-cadastre.jpg',
            format: 'image/png',
            style: 'normal',
        },
        {
            permalinkId: 'ign.plan',
            name: 'Plan IGN',
            layer: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2',
            imagePath: 'img/ign-cadastre.jpg',
            format: 'image/png',
            style: 'normal',
        }
    ],
    /**
     * Config générale des layers à construire
     */
    sharedOptions: {
        matrixSet: 'PM',
        projection: projections_1.mapProjection,
        numZoomLevels: 19,
        geocoderZoom: 12,
        limitSizeToA4: false,
        attribution: [
            // Logo IGN
            `
      <div>
        <a href="https://www.ign.fr" target="_blank">
          <img style="width: 50px; height: 50px; position: relative;" src="https://wxs.ign.fr/static/logos/IGN/IGN.gif">
        </a>
      </div>`,
            // Logo Geoportail
            `
      <div>
        <a href="https://www.geoportail.gouv.fr/" target="_blank">
          <img style="height: 24px; position: relative;" src="https://www.geoportail.gouv.fr/assets/images/logo-geoportail.svg" alt="Geoportail">
        </a>
      </div>`,
            // Conditions d'utilisation
            `
      <div class="no-print">
        <a href="https://www.geoportail.gouv.fr/depot/api/cgu/CGUF_GP.pdf" style="color: #111; font-size: 10px;" title="Conditions générales d\'utilisation" target="_blank">Conditions générales d\'utilisation</a>
      </div>
      `,
            // Copyright
            `<div class="no-screen">&copy; IGN ${new Date().getFullYear()}</div>`,
        ].join(''),
        customScales,
    },
    /**
     * Crée un fond de carte issu de Géoportail.
     */
    buildLayer(layerOptions, applyLimitUsage = false) {
        // Gestion des quotas
        var layerId = layerOptions.layer;
        var limitUsage = applyLimitUsage && layerOptions.limitUsage;
        if (limitUsage) {
            layerId = layerOptions.alternateLayerId;
        }
        var layer = new OpenLayers.Layer.WMTS(Object.assign(Object.assign({}, this.sharedOptions), { name: layerOptions.name, layer: layerId, permalinkId: layerOptions.permalinkId, imagePath: layerOptions.imagePath, 
            //url: 'https://wxs.ign.fr/' + (layerOptions.apiKey || settings.geoportalKey) + '/wmts',
            url: layerOptions.private ? 'https://data.geopf.fr/private/wmts' : 'https://data.geopf.fr/wmts', style: layerOptions.style, format: layerOptions.format, limitUsage: layerOptions.limitUsage, params: layerOptions.private ? { apikey: settings_1.settings.geoportalKey } : undefined }));
        if (limitUsage) {
            layer.events.register('added', layer, onLayerShowed);
            layer.events.register('visibilitychanged', layer, onLayerShowed);
        }
        return layer;
    },
};
exports.default = Geoportal;
/**
 * Appelé lorsqu'un layer est affiché
 */
function onLayerShowed(e) {
    var layer = e.object;
    if (layer.limitUsage && layer.visibility) {
        toastr_1.default.info((0, locale_1.t)('geoportal.limitUsage'));
    }
}
